import actions from './actions';
import getters from './getters';
import mutations from './mutations';
import {validation} from "./validation";

export default {
    state: {
        user_id : 0,
        firms: [], // массив объектов организаций пользователя
        firm_default_id: 0, // id организации по умолчанию
        favcount: 0, // число Избранных товаров
        comparecount: 0, // число товаров в Сравнении
        compareinfo : {name: '', category: '', count: 0, count_txt: '', is_ok: true},
        message: "",
        validation
    },
    mutations,
    actions,
    getters
}
